<template lang="html">

    <section class="cover-popup row-center" v-if="!!error">

        <div class="popup">
            <h2 v-html="$t(`errors[${error}]`).titulo"></h2>
            <p v-html="$t(`errors[${error}]`).cuerpo"></p>
            <a class="btn-enviar -blue -enviar-white" @click="eraseError">{{$t('generales.aceptar')}}</a>
        </div>

    </section>

</template>

<script lang="js">
  
  
    import {mapGetters} from 'vuex'

    import { mapActions } from 'vuex';

  
    export default  {
      name: 'popup-error',
      computed:{
        ...mapGetters({
            error : 'getError'
        })
      },
      methods: {
            ...mapActions([
                'eraseError',
            ])
        },
  }
  </script>
<style lang="scss" scoped>

    .cover-popup{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .7);
        z-index: 10;
        padding: 20px;

        .popup{
            background: white;
            display: inline-block;
            padding:20px;
            width: 100%;
            max-width: 500px;
            border-radius:10px;
        }
    }

  </style>


// WEBPACK FOOTER //
// src/components/parts/popup-error.vue